import { useQuery } from '@tanstack/react-query';
import { getStoreTracking } from '@/api/tracking';

/**
 * Fetch per-store public tracking settings (Meta / GA4 / Google Ads).
 * Cached for 5 minutes.
 */
export function useStoreTracking(storeDomain: string | null) {
  return useQuery({
    queryKey: ['store-tracking', storeDomain],
    queryFn: () => {
      if (!storeDomain) {
        throw new Error('Store domain is required');
      }
      return getStoreTracking(storeDomain);
    },
    enabled: !!storeDomain,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}
